import { SectionBgAdaptiveView } from '../../ui_canvas_engine/SectionBgViewAdaptive.ts';
import { SpriteView } from '../../ui_canvas_engine/SpriteView.ts';
import { TextView } from '../../ui_canvas_engine/TextView.ts';
import { GameFont } from '../../GameFont.ts';
import { GameColor } from '@colonist/ui-game';
import { Sprites } from '../UIGameImageDictionary.ts';
import { UIGameSpriteHandler } from '../../UIGameSpriteHandler.ts';
export class UIGameBeginnerHintInformationView extends SectionBgAdaptiveView {
    setTitle() {
        const tipTitleText = {
            key: 'strings:game.beginnerTips.actionHints.title'
        };
        const tipTitleX = this.tipIcon.x + this.tipIcon.width + this.margin;
        const tipTitleY = this.uiGameManager.canvasController.margin;
        const tipTitleWidth = this.itemSize * 2.5;
        const tipTitleHeight = this.itemSize * 0.4;
        this.tipTitle = new TextView(tipTitleText, tipTitleX, tipTitleY, tipTitleWidth, tipTitleHeight, this, GameFont.Size.Normal, GameColor.getColor(GameColor.Color.White));
        this.tipTitle.changeStyle({
            fontWeight: GameFont.Weight.Bold
        });
    }
    setDescription(descriptionText) {
        const tipDescriptionX = this.tipIcon.x + this.tipIcon.width + this.margin;
        const tipDescriptionWidth = this.itemSize * 2.5;
        const tipDescriptionHeight = this.itemSize / 3;
        this.tipDescription = new TextView(descriptionText, tipDescriptionX, 0, tipDescriptionWidth, tipDescriptionHeight, this, GameFont.Size.Small, GameColor.getColor(GameColor.Color.White));
        this.tipDescription.changeStyle({
            align: 'left'
        });
        this.tipDescription.y = this.tipTitle.y + this.tipTitle.height + this.uiGameManager.canvasController.margin * 2;
    }
    setLayout(hintIcon) {
        this.tipIcon.height = this.tipTitle.height + this.margin + this.tipDescription.height;
        this.tipIcon.width = this.tipIcon.height * (hintIcon.width / hintIcon.height);
        this.tipTitle.x = this.tipIcon.x + this.tipIcon.width + this.margin;
        this.tipDescription.x = this.tipIcon.x + this.tipIcon.width + this.margin;
    }
    toggleVisibility() {
        this.visible = !this.visible;
    }
    constructor(uiGameManager, hintIndicator, descriptionText, hintIcon){
        super();
        this.uiGameManager = uiGameManager;
        this.itemSize = uiGameManager.canvasController.itemSize;
        this.margin = this.itemSize * 0.1;
        hintIndicator.parent.addChild(this);
        const backgroundRadius = 8;
        const iconWidth = this.itemSize * 0.5;
        const iconHeight = iconWidth * (hintIcon.height / hintIcon.width);
        const iconY = this.margin * 1.2;
        this.tipIcon = new SpriteView(this.margin, iconY, iconWidth, iconHeight, this, hintIcon);
        this.setTitle();
        this.setDescription(descriptionText);
        this.setLayout(hintIcon);
        this.drawTextureBgAroundContent(this.margin, this.margin, UIGameSpriteHandler.getTextureFromSpritesheet(Sprites.bg_section_dark), backgroundRadius);
        const shouldInfoBoxAppearOnLeft = hintIndicator.getGlobalPosition().x > (this.uiGameManager.canvasController.appW - this.uiGameManager.canvasController.chatWidth) / 2;
        const xIfOnRight = hintIndicator.x + hintIndicator.width + this.uiGameManager.canvasController.margin;
        const xIfOnLeft = hintIndicator.x - this.absoluteWidth - this.uiGameManager.canvasController.margin;
        this.x = shouldInfoBoxAppearOnLeft ? xIfOnLeft : xIfOnRight;
        this.y = hintIndicator.y + (hintIndicator.height - this.height) / 2 - this.uiGameManager.canvasController.margin;
        this.zIndex = this.uiGameManager.mapController.mapView.layers.informationPopups;
        this.visible = false;
        this.tipIcon.y = this.absoluteHeight / 2 - this.tipIcon.height / 2;
    }
}
